class MeasureType {
    measureTypeId: string;
    
    measureRepresentationId: string;

    measureShapeId: string;
    
    name: string;
    
    dataInformations: Record<string, unknown> | undefined = undefined;
    
    dataFormatType: Record<string, unknown> | undefined = undefined;

    dataFormatInstance: Record<string, unknown> | undefined = undefined;
    
    constructor(measureTypeId: string, measureRepresentationId: string, measureShapeId: string, name: string, dataInformations?: Record<string, unknown>, dataFormatType?: Record<string, unknown>, dataFormatInstance?: Record<string, unknown>) {
        this.measureTypeId = measureTypeId;
        this.measureRepresentationId = measureRepresentationId;
        this.measureShapeId = measureShapeId;
        this.name = name;
        this.dataInformations = dataInformations;
        this.dataFormatType = dataFormatType;
        this.dataFormatInstance = dataFormatInstance;
    }
}

export default MeasureType;